import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGroup, IGroups, IUserAccessToGroup } from '@interfaces/IGroup';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GroupsViewService {
  constructor(private _http: HttpClient) {}

  getGroupDetail(id: number): Observable<IGroup> {
    const url = `${environment.baseUrl}api/v1/groups/${id}/`;
    return this._http.get<IGroup>(url);
  }

  getGroups(qParams?: { [key: string]: string }): Observable<IGroups> {
    const url = `${environment.baseUrl}api/v1/groups/`;
    return this._http.get<IGroups>(url, { params: qParams });
  }

  getAllCourseGroups(id: number): Observable<IGroups> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/groups/`;
    return this._http.get<IGroups>(url);
  }

  getActiveCourseGroups(
    id: number,
    qParams?: { [key: string]: string | boolean }
  ): Observable<IGroups> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/groups/active/`;
    return this._http.get<IGroups>(url, { params: qParams });
  }

  getInactiveCourseGroups(id: number): Observable<IGroups> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/groups/inactive/`;
    return this._http.get<IGroups>(url);
  }

  getStudentAccess(groupId: number, studentId: number) {
    const url = `${environment.baseUrl}api/v1/groups/${groupId}/students/${studentId}/study-period/`;
    return this._http.get<IUserAccessToGroup>(url);
  }
}
